import gql from 'graphql-tag'

/**
 * Query
 */
const ALL_ACTIVE = gql`
  query workDescriptionsActive {
    workDescriptionsActive {
      id
      name
      price
      is_active
      is_group_piecework
      status_text
    }
  }
`

const ALL_ACTIVE_AND_ONLY_PIECEWORK = gql`
  query workDescriptionsActiveAndOnlyPiecework  {
    workDescriptionsActiveAndOnlyPiecework {
      id
      name
      price
      is_active
      is_group_piecework
      status_text
    }
  }
`

const GET_WITH_PAGINATION = gql`
  query workDescriptionsWithPagination ($page: Int, $perPage: Int) {
    workDescriptionsWithPagination (page: $page, first: $perPage) {
      paginatorInfo {
        currentPage
        count
        hasMorePages
        perPage
        total
      }
      data {
        id
        name
        price
        is_active
        is_group_piecework
        status_text
      }
    }
  }
`
/**
 * Mutations
 */
const VALIDATE_NAME = gql`
  mutation validateNameWorkDescription($name: String!) {
    validateNameWorkDescription(name: $name) {
      success
      msgError
    }
  }
`

 const CREATE = gql`
  mutation createWorkDescription ($input: WorkDescriptionForm!) {
    createWorkDescription (input: $input) {
      id
      name
      is_active
      is_group_piecework
      status_text
    }
  }
`

const UPDATE = gql`
  mutation updateWorkDescription ($id: ID!, $input: WorkDescriptionForm!) {
    updateWorkDescription (id: $id, input: $input) {
      id
      name
      is_active
      is_group_piecework
      status_text
    }
  }
`
const CHANGE_STATUS = gql`
  mutation changeStatusWorkDescription ($id: ID!, $input: WorkDescriptionChangeStatus!) {
    changeStatusWorkDescription (id: $id, input: $input) {
      id
    }
  }
`

const DELETE = gql`
  mutation deleteWorkDescription ($id: ID!) {
    deleteWorkDescription (id: $id) {
      id
      name
      is_active
      is_group_piecework
      status_text
    }
  }
`
export {
  ALL_ACTIVE,
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  CHANGE_STATUS,
  DELETE,
  VALIDATE_NAME,
  ALL_ACTIVE_AND_ONLY_PIECEWORK
}
